import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { StudentMultiStepForm } from '../../app/components/student/student-multi-step-form';
import { trpc } from '@org/clients/school';

export const Route = createFileRoute('/students/new')({
  component: StudentCreateRoute,
});

function StudentCreateRoute() {
  const navigate = useNavigate({ from: '/students/new' });
  const utils = trpc.useUtils();

  const handleClose = () => {
    navigate({ to: '/students', replace: true });
  };

  const handleSubmit = async () => {
    await utils.users.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title="Create Student"
      size="xl"
      centered
      body={
        <StudentMultiStepForm
          defaultValues={{}}
          onSubmit={handleSubmit}
          onClose={handleClose}
          isEditing={false}
        />
      }
      footer={<></>}
    />
  );
}


